// generated by genversion
export var version = '3.8.10';
//# sourceMappingURL=version.js.map